import { invokeApi, isCanceledResponse } from "../../bl_libs/invokeApi";
import { programTypesForClassPeriodsApi } from "../../utils/associateCapabilities";

export const class_periods_list_api = async (params = {}, signal = null) => {
  const query = new URLSearchParams();
  if (params.class_id) query.set("class_id", params.class_id);
  if (params.period_type) query.set("period_type", params.period_type);
  if (params.program_type) query.set("program_type", params.program_type);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  return invokeApi({
    path: `api/class-periods${suffix}`,
    method: "GET",
    signal,
  });
};

function compareGeneralClassPeriodRow(a, b) {
  const pt = String(a.program_type || "").localeCompare(String(b.program_type || ""));
  if (pt !== 0) return pt;
  const st = String(a.start_time || "").localeCompare(String(b.start_time || ""));
  if (st !== 0) return st;
  return String(a.title || "").localeCompare(String(b.title || ""));
}

/**
 * Loads general class periods for a class, scoped by the member's portal programs.
 * When the member has both jamia and hifz_ul_quran, merges two API results (backend accepts one program_type per request).
 */
export const general_class_periods_for_member_api = async (classId, userInfo, signal = null) => {
  const types = programTypesForClassPeriodsApi(userInfo);
  const base = { class_id: classId, period_type: "general" };

  if (types.length === 0) {
    return class_periods_list_api(base, signal);
  }
  if (types.length === 1) {
    return class_periods_list_api({ ...base, program_type: types[0] }, signal);
  }

  const results = await Promise.all(
    types.map((program_type) => class_periods_list_api({ ...base, program_type }, signal)),
  );

  for (const r of results) {
    if (isCanceledResponse(r)) return r;
  }

  const failed = results.find((r) => r.code !== 200);
  if (failed) return failed;

  const byId = new Map();
  for (const r of results) {
    for (const row of r.class_periods || []) {
      if (row?._id && !byId.has(row._id)) byId.set(row._id, row);
    }
  }
  const merged = [...byId.values()].sort(compareGeneralClassPeriodRow);

  return {
    code: 200,
    message: results[0]?.message,
    class_periods: merged,
  };
};

export const add_class_period_api = async (data) => {
  return invokeApi({
    path: "api/class-periods",
    method: "POST",
    postData: data,
  });
};

export const update_class_period_api = async (periodId, data) => {
  return invokeApi({
    path: `api/class-periods/${periodId}`,
    method: "PUT",
    postData: data,
  });
};

export const delete_class_period_api = async (periodId) => {
  return invokeApi({
    path: `api/class-periods/${periodId}`,
    method: "DELETE",
  });
};
